/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const IMPORT_USERS = gql`
mutation ImportUsers($users: [ImportUserRecord], $sections: String, $presentation: String, $partition: String, $sectionOptType: String, $invite: Boolean, $inviteType: String, $role: String) {
  importUsers(users: $users, sections: $sections, presentation: $presentation, partition: $partition, sectionOptType: $sectionOptType, invite: $invite, inviteType: $inviteType, role: $role) {
    message
  }
}
`;
